export const GET_PERMISSION_LIST_REQUEST = "GET_PERMISSION_LIST_REQUEST";
export const GET_PERMISSION_LIST_FAILURE = "GET_PERMISSION_LIST_FAILURE";
export const GET_PERMISSION_LIST_SUCCESS = "GET_PERMISSION_LIST_SUCCESS";